export const breakpoints = { // eslint-disable-line import/prefer-default-export
  smallScreen: 320,
  mediumMobile: 540,
  bigMobile: 768,
  desktopNav: 940,
};
